import { basicInitialState } from 'store/_utils/basicInitialState';
import { TVesselsState } from './vesselsModel';

export const vesselsInitialState: TVesselsState = {
  ...basicInitialState,
  historicalVessel: null,
  vessels: []
};
